import {ACTION_CODE} from './_actionCode';
import {ActivitiesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'CREATE_ACTIVITY';

export async function createActivity(token = '', payload: Record<string, unknown>) {
    try {
        LoggerService.logInfo('Action - createActivity - Start');

        const result = await ActivitiesService.createActivity(token, payload);

        LoggerService.logInfo('Action - createActivity - End - Success');

        return ResultModel.newSuccessResult(result);
    }
    catch (error) {
        LoggerService.logInfo('Action - createActivity - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création de l\'activité',
            error: error
        });
        
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
